export default __webpack_public_path__ + "static/media/home-mob-bg1.f8dd7859.png";